componente que reciba dos parametros, uno para el valor y otro para saber si ocultarlo o no ( se culta con *** y un boton para mostrar )

<template>
    <div v-if="!hidden || show">
        <span @click="copyToClipboard(value)" style="cursor: pointer;">{{ value }}</span>
        <small v-if="value && copied" style="cursor: pointer; color: silver; position: absolute;">&nbsp; Copiado</small>
    </div>
    <div v-else>
        {{ value.replace(/./g, '*') }}
        <small v-if="value" @click="show = true" style="cursor: pointer; color: silver;">&nbsp; Mostrar</small>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true
        },
        hidden: {
            type: Boolean,
            default: false
        }
    },    
    data() {
        return {
            show: false,
            copied: false
        }
    },
    methods: {
        copyToClipboard(text) {
            const el = document.createElement('textarea');
            el.value = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 1500);
        }
    }
}
</script>